import { TextareaAutosize } from '@material-ui/core'
import React, { ChangeEvent, FC, ReactElement, Ref, useContext } from 'react'
import {
    Controller,
    ControllerRenderProps,
    useFormContext,
    UseFormMethods
} from '../../../../Vendor/react-hook-form/dist/index.ie11'
import { EMPTY_STRING } from '../../../../NonReact/constants/Common'
import { CommonFormContext, FormContextType } from '../../Contexts/CommonFormContext'
import { IsVarEmpty } from '../../../../NonReact/utils/GlobalFunctions'

export type TextAreaProps = {
    name: string
    label?: string
    disabled?: boolean
    additionalClassNames?: string
    minRows?: number
}

export const TextArea: FC<TextAreaProps> = ({
    name,
    label,
    disabled,
    additionalClassNames,
    minRows = 3
}: TextAreaProps): ReactElement => {
    const commonForm: Nullable<FormContextType> = useContext(CommonFormContext)
    const { control, watch }: UseFormMethods = useFormContext()

    const props = {
        control,
        name,
        defaultValue: watch(name, EMPTY_STRING),
        render: ({
            onChange: onChangeForm,
            onBlur: onBlurForm,
            value: valueForm,
            name: fieldName,
            ref: fieldRef
        }: ControllerRenderProps<Record<string, unknown>>): ReactElement => (
            <TextareaAutosize
                name={fieldName}
                ref={fieldRef as Ref<HTMLTextAreaElement>}
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                value={valueForm as string}
                className={additionalClassNames}
                disabled={disabled}
                minRows={minRows}
                onChange={(e: ChangeEvent<HTMLTextAreaElement>): void => {
                    if (commonForm?.handleFormChange) {
                        commonForm.handleFormChange(name)
                    }
                    onChangeForm(e.target.value)
                }}
                onBlur={() => onBlurForm()}
            />
        )
    }

    return (
        <div className='text-area'>
            {!IsVarEmpty(label) && <label className='label'>{label}</label>}
            <Controller {...props} />
        </div>
    )
}
